import { noop } from '@deltasierra/utilities-object';
import * as React from 'react';
import { LightboxAction } from '../use-lightbox-reducer';

export const LightboxDispatchContext = React.createContext<React.Dispatch<LightboxAction>>(noop);
